<shared-scaffold-for-regular [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</shared-scaffold-for-regular>

<!-- <shared-modals></shared-modals> -->
<!-- <hero-loader moduleName="@shared/core/modules/modals/modals.shared.module#ModalsModule"></hero-loader> -->
<ng-container #modals></ng-container>
<ng-container #cart></ng-container>
<!-- <shared-cart></shared-cart> -->
<!-- <shared-cart-view></shared-cart-view> -->
